import { useEffect } from 'preact/hooks';
import { getWebsiteDataName, getWebsiteDataValue } from '@/utils';
import { useFormProps, useFormStore } from '@/features/form';

export default function ExternalData({ block, state, setNestedValue }) {
	const { formOpen } = useFormStore();
	const { multipleIndex, divName } = useFormProps();
	useEffect(() => {
		setTimeout(() => {
			Object.keys(block.properties.elements).forEach((key, index) => {
				const element = block.properties.elements[key];

				const value = getWebsiteDataValue({
					type: element.type,
					value: element.value,
					divName,
					multipleIndex
				});

				setNestedValue(element.data_field, value);
			});
		}, 300);
	}, [formOpen, block, divName, multipleIndex]);

	return (
		<div>
			{Object.keys(block.properties.elements).map((key, index) => {
				const element = block.properties.elements[key];

				const name = getWebsiteDataName({
					block,
					type: element.type,
					index
				});

				const value = state[element.data_field]?.value;
				return (
					<input
						type="hidden"
						id={name}
						name={name}
						value={value}
					/>
				);
			})}
		</div>
	);
}
